import { render, staticRenderFns } from "./MagneticHysteresisViz.vue?vue&type=template&id=59a77cd3&scoped=true"
import script from "./MagneticHysteresisViz.vue?vue&type=script&lang=js"
export * from "./MagneticHysteresisViz.vue?vue&type=script&lang=js"
import style0 from "./MagneticHysteresisViz.vue?vue&type=style&index=0&id=59a77cd3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59a77cd3",
  null
  
)

export default component.exports